 



// import { useEffect, useState } from "react";
// import Navbar from "../components/Navbar";
// import uploadToCloudinary from "../utils/upload";

// function Handover() {
//   const [activeTab, setActiveTab] = useState("pickup");
//   const [pickupItems, setPickupItems] = useState([]);
//   const [returnRequests, setReturnRequests] = useState([]);
//   const [pageLoading, setPageLoading] = useState(true);

//   const [processingId, setProcessingId] = useState(null); 
//   const [otpInputs, setOtpInputs] = useState({});
//   const [evidenceMap, setEvidenceMap] = useState({}); 

//   // Return specific states
//   const [damageInputs, setDamageInputs] = useState({});
//   const [proofInputs, setProofInputs] = useState({});
//   const [lateFees, setLateFees] = useState({}); // 🔥 LATE FEES STATE
//   const [notes, setNotes] = useState({});

//   const token = localStorage.getItem("token");

//   useEffect(() => { fetchData(); }, []);

//   const fetchData = async () => {
//     if(pickupItems.length === 0) setPageLoading(true);
//     try {
//       // 1. PICKUP DATA
//       const res1 = await fetch("https://borrowhub-backend.onrender.com/api/items/lent-out", {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       const data1 = await res1.json();
//       if (data1.items) {
//         setPickupItems(data1.items.filter(item => item.status === "reserved"));
//       }

//       // 2. RETURN DATA
//       const res2 = await fetch("https://borrowhub-backend.onrender.com/api/return/pending-requests", {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       const data2 = await res2.json();
//       const rawRequests = data2.requests || [];
//       const formattedRequests = rawRequests.map(backendItem => ({
//           _id: backendItem._id, item: backendItem, borrower: backendItem.borrowedBy, borrow: backendItem._id           
//       }));
//       setReturnRequests(formattedRequests);

//       // 🔥🔥🔥 3. CALCULATE LATE FEES LOGIC RESTORED 🔥🔥🔥
//       const calculatedFees = {};
//       formattedRequests.forEach((req) => {
//           if (req.item?.borrowTo) {
//               const dueDate = new Date(req.item.borrowTo);
//               const today = new Date();
              
//               // Calculate difference in time
//               const diffTime = today - dueDate;
//               const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              
//               // Agar din > 0 hain to late hai (Eg: 50rs per day penalty)
//               if (diffDays > 0) {
//                   calculatedFees[req._id] = diffDays * 50; 
//               } else {
//                   calculatedFees[req._id] = 0;
//               }
//           }
//       });
//       setLateFees(calculatedFees);
//       // 🔥🔥🔥 END CALCULATION 🔥🔥🔥

//     } catch (err) { console.error(err); } 
//     finally { setPageLoading(false); }
//   };

//   const handleEvidenceUpload = async (e, itemId) => {
//       const file = e.target.files[0];
//       if (!file) return;
//       const btn = document.getElementById(`cam-btn-${itemId}`);
//       if(btn) btn.innerText = "⏳";

//       try {
//           const url = await uploadToCloudinary(file);
//           if (url) {
//             setEvidenceMap(prev => {
//                 const currentList = prev[itemId] || [];
//                 return { ...prev, [itemId]: [...currentList, url] };
//             });
//           }
//       } catch (err) { alert("Image upload failed."); } 
//       finally { if(btn) btn.innerText = "➕"; }
//   };

//   const handlePickupVerify = async (itemId) => {
//     const otp = otpInputs[itemId];
//     const evidence = evidenceMap[itemId] || [];

//     if (!otp) return alert("Enter Pickup OTP");
//     if (evidence.length < 1) return alert("📸 Please upload at least 1 photo!");

//     setProcessingId(itemId);
//     try {
//       const res = await fetch("https://borrowhub-backend.onrender.com/api/borrows/verify-pickup", {
//         method: "POST",
//         headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//         body: JSON.stringify({ itemId, otp, evidence }), 
//       });

//       const data = await res.json();
//       if (data.success) { 
//           alert("✅ Handover Success!"); 
//           setOtpInputs((prev) => ({...prev, [itemId]: ""}));
//           fetchData(); 
//       } else { alert("❌ " + data.message); }
//     } catch { alert("Server error"); } 
//     finally { setProcessingId(null); }
//   };

//   const handleFileChange = async (e, reqId) => {
//     const file = e.target.files[0];
//     if (!file) return;
//     setProcessingId(reqId);
//     try { const url = await uploadToCloudinary(file); setProofInputs(p => ({...p, [reqId]: url})); } 
//     catch { alert("Upload failed"); } finally { setProcessingId(null); }
//   };
  
//   const handleReturnVerify = async (borrowId, requestId) => {
//     const otp = otpInputs[requestId];
//     if (!otp) return alert("Enter Return OTP");
//     setProcessingId(requestId);
//     try {
//       const res = await fetch(` https://borrowhub-backend.onrender.com/api/return/verify/${borrowId}`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//         body: JSON.stringify({
//           itemId: borrowId, otp, damageClaimed: damageInputs[requestId] || 0,
//           lateFeesCalculated: lateFees[requestId] || 0, // 🔥 Send Calculated Fee
//           lenderComment: notes[requestId] || "", proofImage: proofInputs[requestId] || "",
//         }),
//       });
//       const data = await res.json();
//       if (data.success) { alert(data.message); fetchData(); } else { alert("❌ " + data.message); }
//     } catch { alert("Error"); } finally { setProcessingId(null); }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="container mt-4">
//         <h3 className="fw-bold mb-4">🤝 Handovers</h3>

//         <ul className="nav nav-pills mb-4 nav-justified">
//           <li className="nav-item"><button className={`nav-link fw-bold ${activeTab === "pickup" ? "active bg-dark" : "text-dark"}`} onClick={() => setActiveTab("pickup")}>📤 To Give (Pickup)</button></li>
//           <li className="nav-item"><button className={`nav-link fw-bold ${activeTab === "return" ? "active bg-dark" : "text-dark"}`} onClick={() => setActiveTab("return")}>📥 To Receive (Return)</button></li>
//         </ul>

//         {pageLoading && <div className="spinner-border text-primary d-block mx-auto" />}

//         {/* PICKUP TAB */}
//         {activeTab === "pickup" && (
//           <div className="row g-3">
//             {pickupItems.length === 0 && !pageLoading && <p className="text-center text-muted">No pending pickups.</p>}
//             {pickupItems.map((item) => (
//               <div key={item._id} className="col-md-6">
//                 <div className="card shadow-sm border-warning">
//                   <div className="card-header bg-warning fw-bold">⚠️ Give Item</div>
//                   <div className="card-body">
//                     <h5 className="fw-bold">{item.title}</h5>
//                     <p className="text-muted small">Borrower: {item.borrowedBy?.name}</p>
                    
//                     <div className="mb-3 p-2 bg-light rounded border">
//                         <label className="small fw-bold text-muted mb-2 d-block">📸 Upload Proof (Required)</label>
//                         <div className="d-flex gap-2 flex-wrap mb-2">
//                             {(evidenceMap[item._id] || []).map((url, idx) => (
//                                 <img key={idx} src={url} alt="proof" style={{width: 50, height: 50, borderRadius: 4, objectFit: "cover", border: "1px solid #ccc"}} />
//                             ))}
//                             <label id={`cam-btn-${item._id}`} className="btn btn-outline-secondary btn-sm d-flex align-items-center justify-content-center" style={{width: 50, height: 50, cursor: "pointer"}}>
//                                 ➕ <input type="file" hidden accept="image/*" onChange={(e) => handleEvidenceUpload(e, item._id)} />
//                             </label>
//                         </div>
//                     </div>

//                     <div className="input-group">
//                       <input className="form-control text-center fw-bold" placeholder="Enter Pickup OTP" maxLength={4} 
//                         value={otpInputs[item._id] || ""} onChange={(e) => setOtpInputs((p) => ({ ...p, [item._id]: e.target.value }))} />
//                       <button className="btn btn-dark" onClick={() => handlePickupVerify(item._id)} disabled={processingId === item._id}>
//                         {processingId === item._id ? "..." : "Verify"}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         {/* RETURN TAB */}
//         {activeTab === "return" && (
//           <div className="row g-3">
//              {returnRequests.map((req) => (
//                <div key={req._id} className="col-md-6">
//                   <div className="card shadow-sm border-success">
//                      <div className="card-header bg-success text-white fw-bold d-flex justify-content-between">
//                         <span>✅ Take Item Back</span>
//                         {/* 🔥 LATE BADGE UI RESTORED */}
//                         {lateFees[req._id] > 0 && <span className="badge bg-danger">LATE: ₹{lateFees[req._id]}</span>}
//                      </div>
//                      <div className="card-body">
//                         <h5 className="fw-bold">{req.item?.title}</h5>
                        
//                         {/* Auto Late Fee Display */}
//                         <div className="mb-2">
//                             <label className="small text-muted fw-bold">Late Fee (Auto): ₹{lateFees[req._id] || 0}</label>
//                         </div>

//                         <input className="form-control text-center fw-bold mb-3" placeholder="Return OTP" maxLength={6} 
//                            value={otpInputs[req._id] || ""} onChange={(e) => setOtpInputs((p) => ({ ...p, [req._id]: e.target.value }))} />
                        
//                         <button className="btn btn-success w-100 fw-bold" onClick={() => handleReturnVerify(req.borrow, req._id)} disabled={processingId === req._id}>
//                             Verify & Finish
//                         </button>
//                      </div>
//                   </div>
//                </div>
//              ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }
// export default Handover;import { useEffect, useState } from "react";



// import Navbar from "../components/Navbar";
// import uploadToCloudinary from "../utils/upload";
//  import React, { useEffect, useState } from "react";
//  import "./Auth.css";
 

// function Handover() {
//   const [activeTab, setActiveTab] = useState("pickup");
//   const [pickupItems, setPickupItems] = useState([]);
//   const [returnRequests, setReturnRequests] = useState([]);
//   const [pageLoading, setPageLoading] = useState(true);

//   const [processingId, setProcessingId] = useState(null); 
//   const [otpInputs, setOtpInputs] = useState({});
//   const [evidenceMap, setEvidenceMap] = useState({}); 

//   const [damageInputs, setDamageInputs] = useState({});
//   const [proofInputs, setProofInputs] = useState({});
//   const [lateFees, setLateFees] = useState({}); 
//   const [notes, setNotes] = useState({});

//   const token = localStorage.getItem("token");

//   useEffect(() => { fetchData(); }, []);

//   const fetchData = async () => {
//     if(pickupItems.length === 0) setPageLoading(true);
//     try {
//       const res1 = await fetch("https://borrowhub-backend.onrender.com/api/items/lent-out", {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       const data1 = await res1.json();
//       if (data1.items) {
//         setPickupItems(data1.items.filter(item => item.status === "reserved"));
//       }

//       const res2 = await fetch("https://borrowhub-backend.onrender.com/api/return/pending-requests", {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       const data2 = await res2.json();
//       const rawRequests = data2.requests || [];
//       const formattedRequests = rawRequests.map(backendItem => ({
//           _id: backendItem._id, item: backendItem, borrower: backendItem.borrowedBy, borrow: backendItem._id           
//       }));
//       setReturnRequests(formattedRequests);

//       const calculatedFees = {};
//       formattedRequests.forEach((req) => {
//           if (req.item?.borrowTo) {
//               const dueDate = new Date(req.item.borrowTo);
//               const today = new Date();
//               const diffTime = today - dueDate;
//               const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
//               if (diffDays > 0) {
//                   calculatedFees[req._id] = diffDays * 50; 
//               } else {
//                   calculatedFees[req._id] = 0;
//               }
//           }
//       });
//       setLateFees(calculatedFees);

//     } catch (err) { console.error(err); } 
//     finally { setPageLoading(false); }
//   };

//   const handleEvidenceUpload = async (e, itemId) => {
//       const file = e.target.files[0];
//       if (!file) return;
//       const btn = document.getElementById(`cam-btn-${itemId}`);
//       if(btn) btn.innerText = "⏳";

//       try {
//           const url = await uploadToCloudinary(file);
//           if (url) {
//             setEvidenceMap(prev => {
//                 const currentList = prev[itemId] || [];
//                 return { ...prev, [itemId]: [...currentList, url] };
//             });
//           }
//       } catch (err) { alert("Image upload failed."); } 
//       finally { if(btn) btn.innerText = "➕"; }
//   };

//   const handlePickupVerify = async (itemId) => {
//     const otp = otpInputs[itemId];
//     const evidence = evidenceMap[itemId] || [];

//     if (!otp) return alert("Enter Pickup OTP");
//     if (evidence.length < 1) return alert("📸 Please upload at least 1 photo!");

//     setProcessingId(itemId);
//     try {
//       const res = await fetch("https://borrowhub-backend.onrender.com/api/borrows/verify-pickup", {
//         method: "POST",
//         headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//         body: JSON.stringify({ itemId, otp, evidence }), 
//       });

//       const data = await res.json();
//       if (data.success) { 
//           alert("✅ Handover Success!"); 
//           setOtpInputs((prev) => ({...prev, [itemId]: ""}));
//           fetchData(); 
//       } else { alert("❌ " + data.message); }
//     } catch { alert("Server error"); } 
//     finally { setProcessingId(null); }
//   };

//   const handleReturnVerify = async (borrowId, requestId) => {
//     const otp = otpInputs[requestId];
//     if (!otp) return alert("Enter Return OTP");
//     setProcessingId(requestId);
//     try {
//       const res = await fetch(` https://borrowhub-backend.onrender.com/api/return/verify/${borrowId}`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
//         body: JSON.stringify({
//           itemId: borrowId, otp, damageClaimed: damageInputs[requestId] || 0,
//           lateFeesCalculated: lateFees[requestId] || 0, 
//           lenderComment: notes[requestId] || "", proofImage: proofInputs[requestId] || "",
//         }),
//       });
//       const data = await res.json();
//       if (data.success) { alert(data.message); fetchData(); } else { alert("❌ " + data.message); }
//     } catch { alert("Error"); } finally { setProcessingId(null); }
//   };

//   return (
//     <>
//       <Navbar />
//       <div className="container mt-4">
//         <h3 className="fw-bold mb-4">🤝 Handovers</h3>

//         <ul className="nav nav-pills mb-4 nav-justified">
//           <li className="nav-item"><button className={`nav-link fw-bold ${activeTab === "pickup" ? "active bg-dark" : "text-dark"}`} onClick={() => setActiveTab("pickup")}>📤 To Give (Pickup)</button></li>
//           <li className="nav-item"><button className={`nav-link fw-bold ${activeTab === "return" ? "active bg-dark" : "text-dark"}`} onClick={() => setActiveTab("return")}>📥 To Receive (Return)</button></li>
//         </ul>

//         {pageLoading && <div className="spinner-border text-primary d-block mx-auto" />}

//         {activeTab === "pickup" && (
//           <div className="row g-3">
//             {pickupItems.length === 0 && !pageLoading && <p className="text-center text-muted">No pending pickups.</p>}
//             {pickupItems.map((item) => (
//               <div key={item._id} className="col-md-6">
//                 <div className="card shadow-sm border-warning">
//                   <div className="card-header bg-warning fw-bold">⚠️ Give Item</div>
//                   <div className="card-body">
//                     <h5 className="fw-bold">{item.title}</h5>
//                     <p className="text-muted small">Borrower: {item.borrowedBy?.name}</p>
                    
//                     {/* 🔥 1. BORROWER ID DISPLAY (Passport Size Proof) 🔥 */}
//                     <div className="mb-3 p-2 bg-light rounded border border-danger">
//                         <label className="small fw-bold text-danger mb-2 d-block">🆔 Verify Borrower's Face with ID:</label>
//                         <div className="d-flex align-items-center gap-3">
//                             {item.borrowedBy?.idProof ? (
//                                 <img 
//                                     src={item.borrowedBy.idProof} 
//                                     alt="Borrower ID" 
//                                     style={{width: "70px", height: "90px", borderRadius: "5px", objectFit: "cover", border: "2px solid #dc3545"}} 
//                                 />
//                             ) : (
//                                 <div className="alert alert-danger p-1 small mb-0">ID Not Uploaded!</div>
//                             )}
//                             <div className="small text-muted fw-semibold">
//                                 "Saman dene se pehle face match kar lo."
//                             </div>
//                         </div>
//                     </div>

//                     <div className="mb-3 p-2 bg-light rounded border">
//                         <label className="small fw-bold text-muted mb-2 d-block">📸 Upload Current Condition Proof</label>
//                         <div className="d-flex gap-2 flex-wrap mb-2">
//                             {(evidenceMap[item._id] || []).map((url, idx) => (
//                                 <img key={idx} src={url} alt="proof" style={{width: 50, height: 50, borderRadius: 4, objectFit: "cover", border: "1px solid #ccc"}} />
//                             ))}
//                             <label id={`cam-btn-${item._id}`} className="btn btn-outline-secondary btn-sm d-flex align-items-center justify-content-center" style={{width: 50, height: 50, cursor: "pointer"}}>
//                                 ➕ <input type="file" hidden accept="image/*" onChange={(e) => handleEvidenceUpload(e, item._id)} />
//                             </label>
//                         </div>
//                     </div>

//                     <div className="input-group">
//                       <input className="form-control text-center fw-bold" placeholder="Enter Pickup OTP" maxLength={4} 
//                         value={otpInputs[item._id] || ""} onChange={(e) => setOtpInputs((p) => ({ ...p, [item._id]: e.target.value }))} />
//                       <button className="btn btn-dark" onClick={() => handlePickupVerify(item._id)} disabled={processingId === item._id}>
//                         {processingId === item._id ? "..." : "Verify"}
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         )}

//         {/* RETURN TAB (As it is) */}
//         {activeTab === "return" && (
//           <div className="row g-3">
//              {returnRequests.map((req) => (
//                <div key={req._id} className="col-md-6">
//                   <div className="card shadow-sm border-success">
//                      <div className="card-header bg-success text-white fw-bold d-flex justify-content-between">
//                         <span>✅ Take Item Back</span>
//                         {lateFees[req._id] > 0 && <span className="badge bg-danger">LATE: ₹{lateFees[req._id]}</span>}
//                      </div>
//                      <div className="card-body">
//                         <h5 className="fw-bold">{req.item?.title}</h5>
//                         <div className="mb-2">
//                             <label className="small text-muted fw-bold">Late Fee (Auto): ₹{lateFees[req._id] || 0}</label>
//                         </div>
//                         <input className="form-control text-center fw-bold mb-3" placeholder="Return OTP" maxLength={6} 
//                            value={otpInputs[req._id] || ""} onChange={(e) => setOtpInputs((p) => ({ ...p, [req._id]: e.target.value }))} />
//                         <button className="btn btn-success w-100 fw-bold" onClick={() => handleReturnVerify(req.borrow, req._id)} disabled={processingId === req._id}>
//                             Verify & Finish
//                         </button>
//                      </div>
//                   </div>
//                </div>
//              ))}
//           </div>
//         )}
//       </div>
//     </>
//   );
// }
// export default Handover;




import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import uploadToCloudinary from "../utils/upload";

function Handover() {
  const [activeTab, setActiveTab] = useState("pickup");
  const [pickupItems, setPickupItems] = useState([]);
  const [returnRequests, setReturnRequests] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);

  const [processingId, setProcessingId] = useState(null); 
  const [otpInputs, setOtpInputs] = useState({});
  const [evidenceMap, setEvidenceMap] = useState({}); 

  // Return specific states
  const [damageInputs, setDamageInputs] = useState({});
  const [proofInputs, setProofInputs] = useState({});
  const [lateFees, setLateFees] = useState({}); 
  const [notes, setNotes] = useState({});

  const token = localStorage.getItem("token");

  // 🔥 1. FETCH DATA (With Silent Mode for Auto-Sync)
  const fetchData = async (isSilent = false) => {
    if (!isSilent) setPageLoading(true);
    try {
      // PICKUP DATA
      const res1 = await fetch("https://borrowhub-backend.onrender.com/api/items/lent-out", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data1 = await res1.json();
      if (data1.items) {
        setPickupItems(data1.items.filter(item => item.status === "reserved"));
      }

      // RETURN DATA
      const res2 = await fetch("https://borrowhub-backend.onrender.com/api/return/pending-requests", {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data2 = await res2.json();
      const rawRequests = data2.requests || [];
      // const formattedRequests = rawRequests.map(backendItem => ({
      //     _id: backendItem._id, item: backendItem, borrower: backendItem.borrowedBy, borrow: backendItem._id           
      // }));
      const formattedRequests = rawRequests.map(backendItem => ({
    _id: backendItem._id, 
    item: backendItem.item,       // 🔥 Item ka actual data
    borrower: backendItem.borrower, // 🔥 Ye Borrower ka sahi naam aur details layega
    borrow: backendItem._id          
}));
      setReturnRequests(formattedRequests);

      // Late Fees Calculation
      const calculatedFees = {};
      formattedRequests.forEach((req) => {
          if (req.item?.borrowTo) {
              const dueDate = new Date(req.item.borrowTo);
              const today = new Date();
              const diffTime = today - dueDate;
              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              calculatedFees[req._id] = diffDays > 0 ? diffDays * 50 : 0;
          }
      });
      setLateFees(calculatedFees);

    } catch (err) { 
        console.error("Fetch error:", err); 
    } finally { 
        if (!isSilent) setPageLoading(false); 
    }
  };

  // 🔥 2. AUTO-SYNC LOGIC (Every 2 Seconds)
  useEffect(() => {
    fetchData(); // Initial load

    const interval = setInterval(() => {
      fetchData(true); // Silent sync in background
    }, 2000); // 2 Seconds

    return () => clearInterval(interval); // Cleanup
  }, []);

  // --- Handlers ---
  const handleEvidenceUpload = async (e, itemId) => {
      const file = e.target.files[0];
      if (!file) return;
      const btn = document.getElementById(`cam-btn-${itemId}`);
      if(btn) btn.innerText = "⏳";

      try {
          const url = await uploadToCloudinary(file);
          if (url) {
            setEvidenceMap(prev => {
                const currentList = prev[itemId] || [];
                return { ...prev, [itemId]: [...currentList, url] };
            });
          }
      } catch (err) { alert("Image upload failed."); } 
      finally { if(btn) btn.innerText = "➕"; }
  };

  const handlePickupVerify = async (itemId) => {
    const otp = otpInputs[itemId];
    const evidence = evidenceMap[itemId] || [];

    if (!otp) return alert("Enter Pickup OTP");
    if (evidence.length < 1) return alert("📸 Please upload at least 1 photo!");

    setProcessingId(itemId);
    try {
      const res = await fetch("https://borrowhub-backend.onrender.com/api/borrows/verify-pickup", {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({ itemId, otp, evidence }), 
      });

      const data = await res.json();
      if (data.success) { 
          alert("✅ Handover Success!"); 
          setOtpInputs((prev) => ({...prev, [itemId]: ""}));
          fetchData(); 
      } else { alert("❌ " + data.message); }
    } catch { alert("Server error"); } 
    finally { setProcessingId(null); }
  };

  const handleReturnVerify = async (borrowId, requestId) => {
    const otp = otpInputs[requestId];
    if (!otp) return alert("Enter Return OTP");
    setProcessingId(requestId);
    try {
      const res = await fetch(`https://borrowhub-backend.onrender.com/api/return/verify/${borrowId}`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${token}` },
        body: JSON.stringify({
          itemId: borrowId, otp, damageClaimed: damageInputs[requestId] || 0,
          lateFeesCalculated: lateFees[requestId] || 0, 
          lenderComment: notes[requestId] || "", proofImage: proofInputs[requestId] || "",
        }),
      });
      const data = await res.json();
      if (data.success) { alert(data.message); fetchData(); } else { alert("❌ " + data.message); }
    } catch { alert("Error"); } finally { setProcessingId(null); }
  };

  return (
    <>
      <Navbar />
      <div className="container mt-4 pb-5">
        
        {/* HEADER WITH SYNC CONTROLS */}
        <div className="d-flex justify-content-between align-items-center mb-4">
            <h3 className="fw-bold m-0">🤝 Handovers</h3>
            <div className="d-flex align-items-center gap-2">
                <span className="badge bg-success bg-opacity-10 text-success border border-success border-opacity-25 fw-normal">
                    ● Live Sync (2s)
                </span>
                <button className="btn btn-sm btn-dark fw-bold px-3" onClick={() => fetchData()}>
                    🔄 Sync Now
                </button>
            </div>
        </div>

        <ul className="nav nav-pills mb-4 nav-justified">
          <li className="nav-item"><button className={`nav-link fw-bold ${activeTab === "pickup" ? "active bg-dark" : "text-dark"}`} onClick={() => setActiveTab("pickup")}>📤 To Give (Pickup)</button></li>
          <li className="nav-item"><button className={`nav-link fw-bold ${activeTab === "return" ? "active bg-dark" : "text-dark"}`} onClick={() => setActiveTab("return")}>📥 To Receive (Return)</button></li>
        </ul>

        {pageLoading && <div className="spinner-border text-primary d-block mx-auto" />}

        {/* PICKUP TAB */}
        {activeTab === "pickup" && (
          <div className="row g-3">
            {pickupItems.length === 0 && !pageLoading && <p className="text-center text-muted mt-5">No pending pickups. Everything is synced!</p>}
            {pickupItems.map((item) => (
              <div key={item._id} className="col-md-6">
                <div className="card shadow-sm border-warning rounded-4 overflow-hidden">
                  <div className="card-header bg-warning fw-bold border-0 py-3">⚠️ Give Item (Action Required)</div>
                  <div className="card-body p-4">
                    <h5 className="fw-bold mb-1">{item.title}</h5>
                    <p className="text-muted small mb-3">Borrower: <strong>{item.borrowedBy?.name}</strong></p>
                    
                    {/* 🔥 BORROWER ID DISPLAY (Passport Size) 🔥 */}
                    <div className="mb-4 p-3 bg-light rounded-4 border border-danger border-opacity-25" style={{backgroundColor: "#fff5f5"}}>
                        <label className="small fw-bold text-danger mb-2 d-block text-uppercase" style={{fontSize: "0.7rem"}}>
                            🆔 Borrower's Verified ID (Verify Face)
                        </label>
                        <div className="d-flex align-items-center gap-3">
                             {item.borrowedBy?.idProof ? (
    <a href={item.borrowedBy.idProof} target="_blank" rel="noreferrer">
        <img 
            src={item.borrowedBy.idProof} 
            alt="ID" 
            title="Click to zoom"
            style={{width: "75px", height: "95px", borderRadius: "8px", objectFit: "cover", border: "2px solid #dc3545", backgroundColor: "#eee", cursor: "pointer"}} 
        />
    </a>
) : (
                                <div className="bg-white border rounded-3 d-flex align-items-center justify-content-center text-danger small fw-bold text-center p-2" style={{width: "75px", height: "95px"}}>
                                    ID NOT <br/> FOUND
                                </div>
                            )}
                            <div className="small text-muted" style={{lineHeight: "1.3"}}>
                                <span className="d-block fw-bold text-dark">Face Match Check:</span>
                                Check if the person standing in front matches this photo.
                            </div>
                        </div>
                    </div>

                    <div className="mb-3 p-3 bg-light rounded-4 border">
                        <label className="small fw-bold text-muted mb-2 d-block text-uppercase" style={{fontSize: "0.7rem"}}>📸 Upload Current Condition Proof</label>
                        <div className="d-flex gap-2 flex-wrap mb-2">
                            {(evidenceMap[item._id] || []).map((url, idx) => (
                                <img key={idx} src={url} alt="proof" style={{width: 55, height: 55, borderRadius: 8, objectFit: "cover", border: "1px solid #ccc"}} />
                            ))}
                            <label id={`cam-btn-${item._id}`} className="btn btn-outline-secondary border-dashed d-flex align-items-center justify-content-center" style={{width: 55, height: 55, cursor: "pointer", borderRadius: 8}}>
                                ➕ <input type="file" hidden accept="image/*" onChange={(e) => handleEvidenceUpload(e, item._id)} />
                            </label>
                        </div>
                    </div>

                    <div className="input-group input-group-lg mt-4">
                      <input className="form-control text-center fw-bold" placeholder="0000" maxLength={4} 
                        style={{letterSpacing: "8px", fontSize: "1.5rem"}}
                        value={otpInputs[item._id] || ""} onChange={(e) => setOtpInputs((p) => ({ ...p, [item._id]: e.target.value }))} />
                      <button className="btn btn-dark fw-bold px-4" onClick={() => handlePickupVerify(item._id)} disabled={processingId === item._id}>
                        {processingId === item._id ? "..." : "VERIFY"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* RETURN TAB (Intact) */}
        {activeTab === "return" && (
          <div className="row g-3">
             {returnRequests.map((req) => (
               <div key={req._id} className="col-md-6">
                  <div className="card shadow-sm border-success rounded-4 overflow-hidden">
                     <div className="card-header bg-success text-white fw-bold d-flex justify-content-between py-3 border-0">
                        <span>✅ Take Item Back</span>
                        {lateFees[req._id] > 0 && <span className="badge bg-danger rounded-pill">LATE: ₹{lateFees[req._id]}</span>}
                     </div>
                     <div className="card-body p-4">
                        <h5 className="fw-bold mb-1">{req.item?.title}</h5>
                        <p className="text-muted small mb-3">Returning from: <strong>{req.borrower?.name}</strong></p>
                        
                        <div className="mb-3">
                            <label className="small text-muted fw-bold text-uppercase" style={{fontSize: "0.7rem"}}>Late Penalty Fees</label>
                            <div className="h4 fw-bold text-success">₹{lateFees[req._id] || 0}</div>
                        </div>

                        <input className="form-control text-center fw-bold mb-3 form-control-lg" placeholder="ENTER RETURN OTP" maxLength={6} 
                           style={{letterSpacing: "4px"}}
                           value={otpInputs[req._id] || ""} onChange={(e) => setOtpInputs((p) => ({ ...p, [req._id]: e.target.value }))} />
                        
                        <button className="btn btn-success w-100 fw-bold py-3 rounded-3" onClick={() => handleReturnVerify(req.borrow, req._id)} disabled={processingId === req._id}>
                            {processingId === req._id ? "Processing..." : "CONFIRM RECEIPT & FINISH"}
                        </button>
                     </div>
                  </div>
               </div>
             ))}
          </div>
        )}
      </div>
    </>
  );
}
export default Handover;